<template>
  <section class="invoice-preview-wrapper mt-2">
    <b-row class="invoice-preview">

      <!-- Right Col: Card -->
      <b-col
        cols="12"
        md="4"
        xl="3"
        class="invoice-actions"
      >
        <b-card>

          <!-- Button: Send Invoice -->
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mb-75"
            block
            @click="printInvoice"
          >
            Imprimir
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            v-b-modal.modal-prevent-closing
            variant="warning"
            class="mb-75"
            block
          >
            Agregar/Cambiar datos de firma
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="info"
            class="mb-75"
            block
            @click="loadAlumnos()"
          >
            Actualizar
          </b-button>
          <!-- Spacer -->
          <hr
            class="invoice-spacing"
          >

          <!-- Note -->
          <b-card-body
            class="invoice-padding pt-0 text-center"
          >
            <span class="font-weight-bold">Nota: </span>
            <span>Recuerde que al firmar el documento, autoriza la información como legítima y válida.</span>
          </b-card-body>
          <!-- like footer -->
          <template #footer>
            <em>Al terminar puede cerrar esta ventana</em>
          </template>

        </b-card>
      </b-col>

      <!-- Col: Left (Invoice Container) -->
      <b-col
        cols="12"
        xl="9"
        md="8"
      >
        <b-card
          no-body
          class="invoice-preview-card"
        >
          <!-- Header -->
          <b-card-body class="invoice-padding pb-0">
            <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
              <!-- Header: Left Content -->
              <div>
                <div class="logo-wrapper m-0">
                  <logo />
                </div>
              </div>
            </div>
          </b-card-body>

          <!-- lo que se imprime -->
          <b-overlay
            :show="showLoader"
            rounded="sm"
          >
            <b-table-lite
              responsive
              :items="salonreport"
              :fields="(tipoReporte == 5)?columnsCHYJ:columnsCC"
              :busy="showLoader"
              show-empty
              empty-text="No se encontraron resultados"
            >
              <!-- Head -->
              <template #thead-top>
                <b-tr>
                  <b-th
                    colspan="4"
                  >
                    Posgrado: <code>{{ detallesCurso.plan.nombre }}</code>
                  </b-th>
                  <b-th colspan="2">
                    Periodo: <code> {{ detallesCurso.curso.clv_periodo }}</code>
                  </b-th>
                </b-tr>
              </template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(nombre_completo)="data">
                <b-card-text class="font-weight-bold mb-25">
                  {{ data.item.nombre_completo }}
                </b-card-text>
              </template>
              <template #cell(calif)="data">
                <b-card-text
                  v-for="item in data.item.calif"
                  :key="item.id"
                  class="font-weight-bold mb-25"
                >
                  <span v-show="data.item.calif.length > 1">Parcial: <code>{{ item.numParcial }}</code></span> <code>{{ (tipoReporte == 3)?((item.calif_profesor) ? item.calif_profesor : 'N/A'):(tipoReporte == 4)?((item.calif) ? item.calif : 'N/A') :'N/A' }}</code>
                </b-card-text>
                <b-card-text
                  v-show="data.item.calif.length <= 0"
                  class="font-weight-bold mb-25"
                >
                  SC
                </b-card-text>
              </template>
            </b-table-lite>
            <!-- Spacer -->
            <hr class="invoice-spacing">
            <!-- Note -->
            <b-card-body
              v-if="tipoReporte == 3"
              class="invoice-padding pt-0 text-center"
            >
              <span class="font-weight-bold">Nota: </span>
              <span>Este documento es para uso exclusivo del profesor titular</span>
            </b-card-body>
            <b-card-body
              v-if="tipoReporte == 4"
              class="invoice-padding mt-5 mb-5 pt-0 text-center"
            >
              <span>___________________________________________________________________________________</span><br>
              <span>{{ (tipoReporte == 3)? 'Firma del profesor titular': cargoOpcional }}</span><br>
              <span> {{ (tipoReporte == 3)? detallesCurso.curso.profesor : nombreOpcional }}</span>
            </b-card-body>
            <b-card-body
              v-if="tipoReporte == 5"
              class="invoice-padding mt-5 mb-5  pt-0 text-center"
            >
              <span>{{ (leyendaOpcional !== '')?leyendaOpcional:'Aquí coloca la leyenda o mensaje personalizados' }}</span><br>
              <!-- Spacer -->
              <hr class="invoice-spacing">
              <b-table
                striped
                :items="items"
                small
              />
            </b-card-body>
            <b-card-body class="invoice-padding pt-0 text-center">
              <b-row class="m-0">
                <b-col>
                  <b-row class="text-black-50">
                    <b-col
                      md="12"
                      class="text-center m-2"
                    >
                      <h6>
                        Campus Virtual
                      </h6>
                      <h6>
                        Instituto para el Desarrollo Técnico de las Haciendas Públicas
                      </h6>
                    </b-col>
                  </b-row>
                  <b-row class="mb-0 text-center">
                    <b-col>
                      <p>
                        <span class="d-block d-md-inline-block mt-25">
                          Derechos Reservados © INDETEC  {{ new Date().getFullYear() }}
                        </span>
                      </p>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-card-body>
          </b-overlay>
        </b-card>
        <b-modal
          id="modal-prevent-closing"
          ref="myModal"
          size="lg"
          title="Cambiar los datos de firma"
          ok-title="Cambiar"
          cancel-variant="outline-secondary"
          @show="resetModal"
          @hidden="resetModal"
          @ok="handleOk"
        >
          <!-- repeater -->
          <template v-if="tipoReporte == 5">
            <div>
              <div>
                <b-form
                  ref="form"
                  class="repeater-form"
                  @submit.prevent="repeateAgain"
                >

                  <!-- Row Loop -->
                  <b-row
                    v-for="(item, index) in items"
                    :id="item.id"
                    :key="item.id"
                    ref="row"
                  >

                    <!-- Definición de cargo -->
                    <b-col md="4">
                      <b-form-group
                        label="Definición de cargo"
                        label-for="item-cargo"
                      >
                        <b-form-input
                          id="item-cargo"
                          v-model="item.cargo"
                          type="text"
                          placeholder="Escribe Firma"
                        />
                      </b-form-group>
                    </b-col>

                    <!-- Nombre -->
                    <b-col md="4">
                      <b-form-group
                        label="Nombre"
                        label-for="item-nombre"
                      >
                        <b-form-input
                          id="item-nombre"
                          v-model="item.nombre"
                          type="text"
                          placeholder="Nombre"
                        />
                      </b-form-group>
                    </b-col>

                    <!-- Remove Button -->
                    <b-col
                      lg="2"
                      md="3"
                      class="mb-50"
                    >
                      <b-button
                        v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                        variant="outline-danger"
                        class="mt-0 mt-md-2"
                        @click="removeItem(index)"
                      >
                        <feather-icon
                          icon="XIcon"
                          class="mr-25"
                        />
                        <span>Delete</span>
                      </b-button>
                    </b-col>
                    <b-col cols="12">
                      <hr>
                    </b-col>
                  </b-row>

                </b-form>
              </div>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                @click="repeateAgain"
              >
                <feather-icon
                  icon="PlusIcon"
                  class="mr-25"
                />
                <span>Agregar persona</span>
              </b-button>
            </div>
          </template>
          <!-- Spacer -->
          <hr
            class="invoice-spacing"
          >
          <form
            v-if="tipoReporte == 5 "
            ref="formulario"
            @submit.prevent
          >
            <b-form-group
              label="Leyenda"
              label-for="leyenda-input"
            >
              <b-form-input
                id="leyenda-input"
                v-model="leyenda"
              />
            </b-form-group>
          </form>
          <validation-observer
            v-if="tipoReporte == 4"
            key=""
            ref="loginValidation"
          >
            <form
              ref="form1"
              @submit.prevent
            >
              <b-form-group
                :state="cargoState"
                label="Definición del cargo"
                label-for="cargo-input"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Definición de cargo"
                  rules="required"
                >
                  <b-form-input
                    id="cargo-input"
                    v-model="cargo"
                    :state="cargoState"
                    required
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group
                :state="nombreState"
                label="Nombre"
                label-for="nombre-input"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Nombre"
                  rules="required"
                >
                  <b-form-input
                    id="nombre-input"
                    v-model="nombre"
                    :state="nombreState"
                    required
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </form>
          </validation-observer>
        </b-modal>
      </b-col>

    </b-row>
  </section>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  ref, onMounted, computed, onUnmounted,
} from '@vue/composition-api'
// import router from '@/router'
import {
  BRow, BCol, BCard, BCardBody, BTableLite, BCardText, BButton, VBToggle, BTr, BTh, BOverlay, BModal, VBModal, BForm, BFormGroup, BFormInput, BTable,
} from 'bootstrap-vue'
import { heightTransition } from '@core/mixins/ui/transition'
import { required } from '@validations'
import { useRouter, isEmptyObject } from '@core/utils/utils'
import Logo from '@core/layouts/components/Logo.vue'
import Ripple from 'vue-ripple-directive'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store/index'
import { timestampToDate } from '@core/utils/filter'
import { reportImpresoCalif, cabecerakardex, reportImpresoResolucion } from './useReportes'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
    'b-modal': VBModal,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BForm,
    BModal,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BTable,
    BFormInput,
    BFormGroup,
    BTr,
    BTh,
    Logo,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
    // InvoiceSidebarAddPayment,
    // InvoiceSidebarSendInvoice,
  },
  mixins: [heightTransition],
  setup(_, { root, refs }) {
    const { route } = useRouter()
    const invoiceData = ref(null)
    const paymentDetails = ref({})
    const detallesCurso = ref({ plan: {}, curso: {} })
    const showLoader = ref(false)
    const toast = useToast()
    // catch values
    const inplan = (route.value.params.pl) ? route.value.params.pl : 0
    const incurso = (route.value.params.crs) ? route.value.params.crs : 0
    const inperiodo = (route.value.params.prd) ? route.value.params.prd : 0
    const tipoReporte = (route.value.params.tdr) ? route.value.params.tdr : 0

    // firma
    const cargoOpcional = ref('Firma del responsable')
    const leyenda = ref('')
    const leyendaOpcional = ref('Aquí escribe tu leyenda')
    const nombreOpcional = ref('Nombre del responsable')
    const cargoState = ref(null)
    const cargo = ref('')
    const nombre = ref('')
    const nombreState = ref(null)

    const elementosTabla = ref([
      {
        nombre: 40, cargo: 'Dickerson', firma: 'Macdonald',
      },
      {
        nombre: 21, cargo: 'Larsen', firma: 'Shaw',
      },
    ])

    // repeater
    const items = ref([{
      cargo: '',
      nombre: '',
      firma: '',
    }])
    const nextTodoId = ref(2)
    const salonreport = ref([])
    const columnsCC = [
      {
        key: 'index',
        label: 'N.',
        sortable: true,
      },
      { key: 'nombre_completo', label: 'Nombre', sortable: true },
      { key: 'matricula', sortable: true },
      {
        key: 'calif', label: 'Calificación',
      },
    ]
    const columnsCHYJ = [
      {
        key: 'index',
        label: 'N.',
        sortable: true,
      },
      { key: 'nombre_completo', label: 'Nombre', sortable: true },
      { key: 'matricula', sortable: true },
      { key: 'materianombre', label: 'Materia', sortable: true },
      { key: 'clavemateria', label: 'Clave', sortable: true },
      { key: 'calif_res', label: 'Calificación', sortable: true },
    ]

    // detalle del curso
    const CabeceraReport = () => {
      showLoader.value = true
      cabecerakardex(inplan, incurso).then(response => {
        detallesCurso.value = response
        showLoader.value = false
      }, error => {
        showLoader.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención en petición [Información Curso]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 9000 })
      })
    }
    const form = ref('')

    const resetModal = () => {
      cargo.value = ''
      cargoState.value = null
      nombre.value = ''
      nombreState.value = null
    }
    const myModal = ref()

    const handleSubmit = () => {
      if (tipoReporte === '4') {
        refs.loginValidation.validate().then(success => {
          cargoState.value = success
          nombreState.value = success
          if (cargo.value !== '') {
            cargoState.value = true
          }
          if (nombre.value !== '') {
            nombreState.value = true
          }
          if (!success) {
            return
          }
          // Push the name to submitted names
          cargoOpcional.value = cargo.value
          nombreOpcional.value = nombre.value
          // Hide the modal manually
          root.$nextTick(() => {
            myModal.value.hide()
          })
        })
      } else if (tipoReporte === '5') {
        leyendaOpcional.value = leyenda.value
        root.$nextTick(() => {
          myModal.value.hide()
        })
      }
    }
    const handleOk = bvModalEvt => {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      handleSubmit()
    }

    // get api cvreportes.js
    const loadAlumnos = () => {
      showLoader.value = true
      reportImpresoCalif(inplan, incurso, inperiodo).then(response => {
        salonreport.value = response.data
        showLoader.value = false
        CabeceraReport()
      }, error => {
        showLoader.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención en petición [alumnos]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 9000 })
      })
    }
    // get api cvreportes.js
    const loadAlumnosResolucion = () => {
      showLoader.value = true
      reportImpresoResolucion(inperiodo).then(response => {
        salonreport.value = response.data
        showLoader.value = false
        CabeceraReport()
      }, error => {
        showLoader.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Atención en petición [alumnos con resolución]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        },
        { timeout: 9000 })
      })
    }

    const printInvoice = () => {
      window.print()
    }
    const profesor = computed(() => store.getters['cuenta/getFullName'])
    const bnd = ref(true)
    const repeateAgain = () => {
      if (bnd.value) {
        heightTransition.methods.trSetHeight(refs.form.scrollHeight.toString())
        bnd.value = false
      }
      items.value.push({
        cargo: '',
        nombre: '',
        firma: '',
      })

      root.$nextTick(() => {
        heightTransition.methods.trAddHeight(refs.row[0].offsetHeight.toString())
      })
    }
    const removeItem = index => {
      items.value.splice(index, 1)
      heightTransition.methods.trTrimHeight(refs.row[0].offsetHeight.toString())
    }
    const initTrHeight = () => {
      heightTransition.methods.trSetHeight(null)
      root.$nextTick(() => {
        if (refs.form !== undefined) heightTransition.methods.trSetHeight(refs.form.scrollHeight.tostring())
      })
    }
    window.addEventListener('resize', initTrHeight)
    onMounted(
      () => {
        // heightTransition.methods.trSetHeight(refs.form.scrollHeight)
        if (tipoReporte === '3' || tipoReporte === '4') {
          loadAlumnos()
        } else if (tipoReporte === '5') {
          loadAlumnosResolucion()
        }
      },
    )
    onUnmounted(
      () => {
        window.removeEventListener('resize', initTrHeight())
      },
    )

    return {
      invoiceData,
      paymentDetails,
      // data
      salonreport,
      detallesCurso,
      inperiodo,
      tipoReporte,
      columnsCC,
      columnsCHYJ,
      profesor,
      // functions
      printInvoice,
      loadAlumnos,
      // flags
      showLoader,
      // tools
      isEmptyObject,
      // date
      timestampToDate,
      // firma
      cargoOpcional,
      leyenda,
      nombreOpcional,
      cargoState,
      cargo,
      nombre,
      nombreState,
      elementosTabla,
      // modal
      resetModal,
      handleOk,
      handleSubmit,
      myModal,
      form,
      required,
      leyendaOpcional,
      // resolucion
      reportImpresoResolucion,
      loadAlumnosResolucion,
      // repeater
      repeateAgain,
      removeItem,
      initTrHeight,
      items,
      nextTodoId,
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>

<style lang="scss">
@media print {

  // Global Styles
  body {
    background-color: transparent !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }
  footer.footer {
    display: none;
  }
  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }
  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
              > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
  .buy-now > img {
    display:none;
  }
}
</style>
<style scoped>
  .headWhite {
      background-color: white !important;
    }
</style>
